<template>
    <!-- 导出模式框 -->
    <Modal v-model="exportModal" width="360" @on-cancel="cancel" :mask-closable="false">
        <p slot="header" style="color:#2d8cf0;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>导出确认</span>
        </p>
        <div style="text-align:center">
            <p>是否需要导出资源的标签?</p>
        </div>
        <div slot="footer">
           <Row :gutter="12">
                <Col span="12">
                    <Button type="primary" size="large" :loading="loading" @click="yes" style="width:100%">是</Button>
                </Col>
                <Col span="12">
                    <Button type="primary" size="large" :loading="modal_loading" @click="no" style="width:100%">否</Button>
                </Col>
            </Row>
           
        </div>
    </Modal>
</template>
<script>
    export default {
        name: 'Export',
        data() {
            return {
                exportModal: false,
                loading:false,
                modal_loading: false,
                type: 0 // 类型  0:计算实例  1:数据库  2:Redshift  3:Elasticsearch  4:Memcached  5:Redis
            }
        },
        methods: {
            // 点击导出
            openExport:function(type){
                this.exportModal=true;
                this.type=type;
            },
            // 是
            yes:function(){
                switch (this.type) {
                    case 0:
                        // 计算实例
                        this.$parent.export(true);
                        break;
                    case 1:
                        // 数据库
                        this.$parent.export(true);
                        break;
                    case 2:
                        // Redshift
                        this.$parent.export(true);
                        break;
                    case 3:
                        // Elasticsearch
                        this.$parent.export(true);
                        break;
                    case 4:
                        // Memcached
                        this.$parent.export(true);
                        break;
                    case 5:
                        // Redis
                        this.$parent.export(true);
                        break;
                    default:
                        break;
                }
            },
            // 否
            no:function(){
                switch (this.type) {
                    case 0:
                        // 计算实例
                        this.$parent.export(false);
                        break;
                    case 1:
                        // 数据库
                        this.$parent.export(false);
                        break;
                    case 2:
                        // Redshift
                        this.$parent.export(false);
                        break;
                    case 3:
                        // Elasticsearch
                        this.$parent.export(false);
                        break;
                    case 4:
                        // Memcached
                        this.$parent.export(false);
                        break;
                    case 5:
                        // Redis
                        this.$parent.export(false);
                        break;
                    default:
                        break;
                }
            },
            // 取消
            cancel:function(){
                this.loading=false;
                this.modal_loading=false;
                this.$Message.destroy();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/Export.vue